import { type Material } from '@babylonjs/core/Materials/material';
import { type MaterialDefines } from '@babylonjs/core/Materials/materialDefines';
import { MaterialPluginBase } from '@babylonjs/core/Materials/materialPluginBase';
import { type AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import { type Scene } from '@babylonjs/core/scene';
import { type Nullable } from '@babylonjs/core/types';

/**
 * Extend from MaterialPluginBase to create your plugin.
 */
export class TonemapPluginMaterial extends MaterialPluginBase {
  constructor(material: Material) {
    // the second parameter is the name of this plugin.
    // the third one is a priority, which lets you define the order multiple plugins are run. Lower numbers run first.
    // the fourth one is a list of defines used in the shader code.
    super(material, 'Tonemap', 200, { CUSTOM_TONEMAPPING: false });

    // let's enable it by default
    this._enable(true);
  }

  // Also, you should always associate a define with your plugin because the list of defines (and their values)
  // is what triggers a recompilation of the shader: a shader is recompiled only if a value of a define changes.
  prepareDefines(defines: MaterialDefines, scene: Scene, mesh: AbstractMesh) {
    defines.CUSTOM_TONEMAPPING = true;
  }

  getClassName() {
    return 'TonemapPluginMaterial';
  }

  getCustomCode(shaderType: string): Nullable<Record<string, string>> {
    if (shaderType === 'fragment') {
      return {
        // TODO: needs tonemap.fragment.fx shader extension.
        CUSTOM_FRAGMENT_TONEMAPPING: `
          colour = exp2(_ExposureAdjustment) * color;
        `,
      };
    }

    return null;
  }
}
